import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import AppointmentErrorContainer from '../../../../components/AppointmentError/AppointmentErrorContainer.js';
import { appointmentErrors } from '../../../../utils/appointments.js';
import { useRescheduleAppointmentContext } from '../../context/context.js';
import RescheduleAppointmentRootContainer from './RescheduleAppointmentContainer.js';
import RescheduleAppointmentRootWithMyAccountEnabled from './RescheduleAppointmentRootWithUserToken.js';

const RescheduleAppointmentRoot = ()=>{
    const { config: { appointmentId , token , cancelAppointmentUrl , bookAppointmentUrl  } ,  } = useRescheduleAppointmentContext();
    const props = {
        cancelAppointmentUrl
    };
    if (appointmentId) {
        return /*#__PURE__*/ React.createElement(RescheduleAppointmentRootWithMyAccountEnabled, swcHelpers.extends({}, props, {
            appointmentId: appointmentId
        }));
    }
    if (token) {
        return /*#__PURE__*/ React.createElement(RescheduleAppointmentRootContainer, swcHelpers.extends({}, props, {
            token: token
        }));
    }
    return /*#__PURE__*/ React.createElement(AppointmentErrorContainer, {
        status: appointmentErrors[0],
        bookAppointmentUrl: bookAppointmentUrl
    });
};

export { RescheduleAppointmentRoot as default };
//# sourceMappingURL=RescheduleAppointmentRoot.js.map
